import service from '@/api/service'

function get () {
  return service.get('/school')
}

function update (schoolId, data) {
  const params = {
    id: `eq.${schoolId}`
  }
  return service.patch('/school', data, { params })
}

function getImage (schoolId) {
  const params = {
    id: `eq.${schoolId}`,
    select: 'image,imagecontain'
  }

  return service.get('/school', { params })
}

function getCategories (schoolId) {
  const params = {
    school_id: `eq.${schoolId}`
  }
  return service.get('/category', { params })
}

function createCommunity (communityName) {
  return service.post('/rpc/add_school', {'school_name': communityName})
}

function getPublic () {
  return service.get('/rpc/school_listing')
}

function getConfig (schoolId) {
  return service.post('/rpc/config', {'space_id': schoolId})
}

function addPage (newPage) {
  const config = {
    headers: {
      PREFER: 'return=representation'
    }
  }

  return service.post('/page', newPage, config)
}

function deletePage (pageId) {
  const params = { id: 'eq.' + pageId }
  return service.delete('/page', { params })
}

function getPages (schoolId) {
  const params = {
    school_id: 'eq.' + schoolId
  }

  return service.get('/page', { params })
}

function getPage (schoolId, page) {
  const params = {
    school_id: 'eq.' + schoolId,
    name: 'eq.' + page
  }

  return service.get('/page', { params })
}

function updatePage (schoolId, page, content) {
  const params = {
    school_id: 'eq.' + schoolId,
    name: 'eq.' + page
  }

  return service.patch('/page', {'content': content}, { params })
}

function updateConfig (schoolId, configKey, configValue) {
  return service.post('/rpc/config_update',
    {
      space_id: schoolId,
      key: configKey,
      value: JSON.stringify(configValue)
    })
}

export default {
  get,
  update,
  getImage,
  getPublic,
  getConfig,
  createCommunity,
  updateConfig,
  getPage,
  addPage,
  deletePage,
  getPages,
  getCategories,
  updatePage
}
